import Vue from 'vue'
import Component from 'vue-class-component'
import StatementView from './StatementView.vue'
import { IConvo } from '@/model/convo'

@Component({
  name: 'convo-statements',
  props: ['convo', 'comment'],
  components: {
    'statement-view': StatementView,
  },
})
export default class ConvoCommentStatements extends Vue {
  react(convo: IConvo) {
  }
}
 